














import { makeImgixUrl } from '@bkwld/cloak/services/helpers'

export default

	props: card: Object

	computed:
		displayImage: -> @card.displayImage?[0]
		download: -> @card.pressKitAsset?[0]
		mimeType: -> @card.pressKitAsset?[0]?.mimeType
		url: -> makeImgixUrl @download?.path

